import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import querystring from "query-string";
import { getMessageBus } from "@jti/fe-message-bus";
import { Button, Card, useTranslations } from "@jti/ui";
import ROUTES_PATHS from "../../../constants/routes";
import { useDeviceRegistrationModel } from "../../../hooks/useDeviceRegistrationModel/useDeviceRegistrationModel";
const NoAccount = () => {
    const history = useHistory();
    const { __ } = useTranslations();
    const { search } = useLocation();
    const { isDeviceRegistrationByLeafletEnabled } = useDeviceRegistrationModel();
    const pushToRegistration = useCallback(() => {
        const messageBus = getMessageBus();
        messageBus.publish("tracking.event", { payload: { event_name: "create_account_click", additionalData: {} } });
        const { returnUrl, s: deviceSerial } = querystring.parse(search);
        if (typeof returnUrl === "string" && returnUrl !== "") {
            history.push(`${ROUTES_PATHS.register}?returnUrl=${encodeURIComponent(returnUrl)}`);
        }
        else if (typeof deviceSerial === "string" && deviceSerial !== "" && isDeviceRegistrationByLeafletEnabled) {
            history.push(`${ROUTES_PATHS.register}?s=${encodeURIComponent(deviceSerial)}`);
        }
        else {
            history.push(ROUTES_PATHS.register);
        }
    }, [history, isDeviceRegistrationByLeafletEnabled, search]);
    return (_jsx(Card, { title: __("login.create_account.title"), description: __("login.create_account.info"), variant: "variant2", titleDataTestId: "createAccountTitle", children: _jsx(Button, { size: "medium", onClick: pushToRegistration, "data-testid": "createAccountButton", children: __("login.create_account.button_label") }) }));
};
export default memo(NoAccount);
